import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  AnnotationState,
  AnnotatorDocumentInfoPayload,
} from "../interfaces/annotator";
import { TextLayer } from "../interfaces/textLayer";
import { AnnotatorErrorType } from "../interfaces/errorType";

interface AnnotatorState {
  textLayer: Array<TextLayer>;
  annotationState: AnnotationState;
  errors: Array<AnnotatorErrorType>;
}

const initialState: AnnotatorState = {
  textLayer: [],
  annotationState: {
    currentPage: 1,
    pages: 0,
    error: false,
  },
  errors: [],
};

export const annotatorSlice = createSlice({
  name: "annotator",
  initialState,
  reducers: {
    setTextLayer: (state, action: PayloadAction<Array<TextLayer>>) => {
      state.textLayer = action.payload;
    },
    setCurrentPage: (state, action: PayloadAction<number>) => {
      state.annotationState.currentPage = action.payload;
    },
    setAnnotatorDocumentInfo: (
      state,
      action: PayloadAction<AnnotatorDocumentInfoPayload>,
    ) => {
      const { pages, error } = action.payload;
      state.annotationState.pages = pages;
      state.annotationState.error = error;
    },
    resetAnnotatorState: (state) => {
      state.annotationState = { ...initialState.annotationState };
      state.textLayer = { ...initialState.textLayer };
    },
    resetAnnotatorReducer: () => initialState,
    setAnnotatorError: (state, action: PayloadAction<AnnotatorErrorType>) => {
      if (!state.errors.includes(action.payload)) {
        state.errors.push(action.payload);
      }
    },
    removeAnnotatorError: (
      state,
      action: PayloadAction<AnnotatorErrorType>,
    ) => {
      state.errors = state.errors.filter((error) => error !== action.payload);
    },
    clearAnnotatorErrors: (state) => {
      state.errors = [];
    },
  },
});

export const {
  setTextLayer,
  setCurrentPage,
  setAnnotatorDocumentInfo,
  resetAnnotatorState,
  resetAnnotatorReducer,
  setAnnotatorError,
  removeAnnotatorError,
  clearAnnotatorErrors,
} = annotatorSlice.actions;

export default annotatorSlice.reducer;
